function typeOf(o) {
  if (o === null) return 'null';
  if (typeof o !== 'object') {
    return typeof o;
  } else {
    const toString = Object.prototype.toString;
    return toString.call(o).slice(8, -1).toLocaleLowerCase();
  }
}

export default typeOf;
